
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';
import { EligibilityListForm, EligibilityListVo } from './eligibilityListForm';

export class CondoneAttendanceForm extends Form {
	private static _instance = new CondoneAttendanceForm();
	subjectSectionId:Field = {
		name:'subjectSectionId'
		,controlType: 'Hidden'
		,label: 'subjectSectionId'
		,isRequired: true
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};
	subjectName:Field = {
		name:'subjectName'
		,controlType: 'Output'
		,label: 'subjectName'
		,valueType: 0
		,defaultValue: ''
		,errorId: 'invalidName'
		,maxLength: 150
	};
	sectionName:Field = {
		name:'sectionName'
		,controlType: 'Output'
		,label: 'sectionName'
		,valueType: 0
		,defaultValue: ''
		,errorId: 'invalidName'
		,maxLength: 150
	};

	students: ChildForm = {
		name:'students',
		form:EligibilityListForm.getInstance(),
		isEditable:false,
		isTabular:true,
		label:'',
		minRows:0,
		maxRows:0,
		errorId:null
	};

	public static getInstance(): CondoneAttendanceForm {
		return CondoneAttendanceForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.controls.set('subjectSectionId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('subjectSectionId', this.subjectSectionId);
		this.controls.set('subjectName', [Validators.maxLength(150)]);
		this.fields.set('subjectName', this.subjectName);
		this.controls.set('sectionName', [Validators.maxLength(150)]);
		this.fields.set('sectionName', this.sectionName);

		this.childForms = new Map();
		this.childForms.set('students', this.students);
		this.opsAllowed = {get: true, update: true};
		this.keyFields = ["subjectSectionId"];
	}

	public getName(): string {
		 return 'condoneAttendance';
	}
}


export class CondoneAttendanceFd extends FormData {
	constructor(form: CondoneAttendanceForm, sa: ServiceAgent) {
		super(form, sa);
	}

	setFieldValue(name: 'subjectSectionId' | 'subjectName' | 'sectionName', value: string | number | boolean | null ): void {
		super.setFieldValue(name, value);
	}

	getFieldValue(name: 'subjectSectionId' | 'subjectName' | 'sectionName' ): string | number | boolean | null {
		return super.getFieldValue(name);
	}
}


export interface CondoneAttendanceVo extends Vo {
	levelSectionId?: number, 
	departmentId?: number, 
	attendanceFrozen?: boolean, 
	cieFrozen?: boolean, 
	sectionId?: number, 
	subjectId?: number, 
	parentId?: number, 
	sectionName?: string, 
	offeredSubjectId?: number, 
	isOffered?: boolean, 
	totalClasses?: number, 
	seasonId?: number, 
	subjectSectionId?: number, 
	instituteId?: number, 
	isIntegrated?: boolean, 
	subjectCode?: string, 
	subjectName?: string, 
	students?: EligibilityListVo
}
